import { CmsObjectWithDefault } from '@components/Cms/types';

export type OtpFormCmsKey =
    | 'OtpTitle'
    | 'EnterTheOtp'
    | 'ResendEmail'
    | 'ContinueText'
    | 'OrText'
    | 'UsePasswordText'
    | 'JtbTooltip'
    | 'JtbModalHeader'
    | 'JtbModalEmailSuggestion'
    | 'JtbModalNotSpam'
    | 'EnterTheOtpWhatsapp'
    | 'OtpVerifyTitle'
    | 'ResendOTPWhatsapp';

export const OtpFormCmsWithDefault: CmsObjectWithDefault<OtpFormCmsKey> = {
    OtpTitle: {
        cmsId: 331881,
        defaultTranslation: 'Sign in with OTP',
    },
    OtpVerifyTitle: {
        cmsId: 168478,
        defaultTranslation: 'Verify phone number',
    },
    EnterTheOtp: {
        cmsId: 331882,
        defaultTranslation: 'Enter the OTP provided in the email sent to {0}.',
    },
    EnterTheOtpWhatsapp: {
        cmsId: 421370,
        defaultTranslation: `We’ve sent a verification code to {0}. 
        Please enter the code below.`,
    },
    ResendEmail: {
        cmsId: 206407,
        defaultTranslation: 'Resend email',
    },
    ResendOTPWhatsapp: {
        cmsId: 421371,
        defaultTranslation: 'Resend code',
    },
    ContinueText: {
        cmsId: 208940,
        defaultTranslation: 'Continue',
    },
    OrText: {
        cmsId: 63536,
        defaultTranslation: 'or',
    },
    UsePasswordText: {
        cmsId: 331880,
        defaultTranslation: 'Use Password',
    },
    JtbTooltip: {
        cmsId: 95750,
        defaultTranslation: 'PIN not received or not working?',
    },
    JtbModalHeader: {
        cmsId: 95754,
        defaultTranslation: "Still didn't receive your PIN code?",
    },
    JtbModalEmailSuggestion: {
        cmsId: 100986,
        defaultTranslation: 'Make sure to use your email address that is registered to your YCS account.',
    },
    JtbModalNotSpam: {
        cmsId: 100988,
        defaultTranslation: 'Make sure to mark all YCS emails as "not spam"',
    },
};
